import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import Axios from '../../../config/axios'
import { UrlConstant } from '../../../commom/UrlConstant'
import { getUserFromLocalStorage } from '../../../utils/utils'
import { useNavigate } from 'react-router-dom'

function MyBlock({ isBlocked }: { isBlocked: boolean }) {
    const user = getUserFromLocalStorage();
    const userId = user?._id;
    const [blockedUsers, setBlockedUsers] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    const handleUnblock = (blockedUserId: string) => {
        Axios.get(UrlConstant.Profile.userUnBlock.replace("{0}", blockedUserId))
            .then(() => {
                setBlockedUsers((prev) =>
                    prev.filter((item) => item.user._id !== blockedUserId)
                );
                navigate('/myprofile')
            })
            .catch((error) => {
                console.error('Error unblocking user:', error);
            });
    };

    useEffect(() => {
        setLoading(true);
        Axios.get(UrlConstant.Profile.userBlockedList)
            .then((response) => {
                if (response.data && response.data.data.blockedUsers) {
                    setBlockedUsers(response.data.data.blockedUsers);
                }
            })
            .catch((error) => {
                console.error('Error fetching blocked users:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [userId]);

    return (
        <Box width="100%">
            <Box padding="20px" overflow="auto" display="flex" alignItems="start" gap="20px" flexWrap="wrap">
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
                        <CircularProgress size={50} sx={{ color: '#F2674A' }} />
                    </Box>
                ) : blockedUsers.length === 0 ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        height="calc(100vh - 71px - 143px)"
                    >
                        <Typography variant="h6" style={{ color: 'white' }}>
                            No Blocked Users
                        </Typography>
                    </Box>
                ) : (
                    blockedUsers.map((item) => (
                        <Box
                            key={item.blockId}
                            className="card"
                            width="48%"
                            padding="20px"
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="space-between"
                            onClick={() => navigate('/userprofile', { state: { userId: item.user._id, isBlockedByUser: isBlocked } })}

                        >
                            <Box display="flex" alignItems="center" gap="10px">
                                <Box
                                    component="img"
                                    src={item.user.profile_pic || ''}
                                    border="1px solid white"
                                    height="42px"
                                    width="42px"
                                    borderRadius="50%"
                                    sx={{ objectFit: 'cover' }}
                                />
                                <Box>
                                    <Typography fontSize="16px" className="text-white" fontWeight="bold">
                                        {item.user.firstName} {item.user.lastName}
                                    </Typography>
                                    <Typography fontSize="12px" className="text-secondary">
                                        {item.user.email}
                                    </Typography>
                                </Box>
                            </Box>

                            <Button
                                variant="outlined"
                                onClick={() => handleUnblock(item.user._id)}
                                style={{
                                    padding: '7px 16px',
                                    borderColor:'red', 
                                    color:'red',
                                    borderRadius: '50px',
                                }}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: '#F2674A1A',
                                        borderColor: '#F2674A',
                                    },
                                }}
                            >
                                Unblock
                            </Button>
                        </Box>
                    ))
                )}
            </Box>
        </Box>
    );
}

export default MyBlock;